// src/Components/Common/ApexBarChart.js

import React, { useState, useEffect } from 'react';
import ApexCharts from 'react-apexcharts';
import { useNavigate } from 'react-router-dom';
import { ProjectStatuses } from '../../constants/Status';
import { useTranslation } from 'react-i18next';

const ApexBarTechnology = ({ data, role }) => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const [categories, setCategories] = useState({
    displayData: [],
    filterData: [],
    value: []
  })

  useEffect(() => {
    if (data?.length > 0) {
      const categoryArray = []
      const categoryValueArray = []
      const displayCategoryArray = [];
      const filterCategoryArray = [];
      data.forEach((item) => {
        if (item.technologyType) {
          categoryArray.push(item.technologyType)
          categoryValueArray.push(item._count)
          displayCategoryArray.push(t(item.technologyType))
          filterCategoryArray.push(item.technologyType)
        }
      })
      setCategories({
        data: categoryArray,
        displayData: displayCategoryArray,
        filterData: filterCategoryArray,
        value: categoryValueArray
      })
    } else {
      setCategories({ displayData: [], filterData: [], value: [] });
    }
  }, [data, t])

  const chartOptions = {
    chart: {
      type: 'bar',
      height: 350,
      events: {
        dataPointSelection: (event, chartContext, { dataPointIndex }) => {
          let filterFields, filterInputs
          if (role) {
            filterFields = ["technologyType", "status", "projectUsers"]
            filterInputs = [categories?.filterData[dataPointIndex], ProjectStatuses.ONGOING, role]
          } else {
            filterFields = ["technologyType", "status"]
            filterInputs = [categories?.filterData[dataPointIndex], ProjectStatuses.ONGOING]
          }
          navigate('/all-projects', {
            state: {
              filterData: JSON.stringify({ filterFields: filterFields, filterInputs: filterInputs })
            }
          })
        }
      },
    },
    plotOptions: {
      bar: {
        horizontal: true, // Make the bars horizontal
        borderRadius: 4,
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val;
      },
      offsetX: -10,
      style: {
        fontSize: '12px',
        colors: ['#fff'],
      },
    },
    xaxis: {
      categories: categories?.displayData?.length > 0 ? categories?.displayData : [],
      title: {
        text: t('Number of Startups'),
      },
    },
    yaxis: {
      title: {
        //text: 'Categories',
      },
    },
    colors: ['#5DD0CA'],
    noData: {
      text: t('No data found'),
      align: 'center',
      verticalAlign: 'middle',
      offsetX: 0,
      offsetY: 0,
      style: {
        color: 'black',
        fontSize: '16px',
      }
    },
    title: {
      //text: 'Horizontal Bar Chart Example',
      align: 'left',
      margin: 10,
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#263238',
      },
    },
  };

  const chartSeries = [
    {
      name: t('Startups'),
      data: categories?.value?.length > 0 ? categories.value : [],
    },
  ];

  return <ApexCharts options={chartOptions} series={chartSeries} type="bar" height={350} />;
};

export default ApexBarTechnology;
